module.exports = __webpack_public_path__ + "static/img/base.a2e0a780.png";